import React from 'react';
import { PagePlaceholder } from '../PagePlaceholder';

export function Transactions() {
  return <PagePlaceholder title="Transactions" />;
}
